import { render, staticRenderFns } from "./JobTitlesAdd.vue?vue&type=template&id=72284252&"
import script from "./JobTitlesAdd.vue?vue&type=script&lang=js&"
export * from "./JobTitlesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports